import { ReactElement } from 'react';

export default function renderTableColumn<V>(v: V): ReactElement {
  return <>{v == null ? '-' : v}</>;
}
